module.exports = __webpack_public_path__ + "static/media/map.c15db9bb.png";